import type { RouteRecordRaw } from 'vue-router'

import { ROUTE_NAMES } from '~/constants/routes'

const routes = (): RouteRecordRaw[] => {
  return [
    {
      name: ROUTE_NAMES.KYB.INDEX,
      component: () => import('~/scopes/kyb/pages/Index.vue'),
      path: '/bo-seller/kyb',
      meta: {
        businessFeatures: ['isNewKybEnabled'],
        owners: ['bot-squad-seller-experience-front'],
      },
      children: [
        {
          name: ROUTE_NAMES.KYB.STEPS.STEP_1,
          component: () =>
            import(
              '~/scopes/kyb/pages/components/steps/BusinessDetails/BusinessDetails.vue'
            ),
          path: 'step-1',
          meta: {
            owners: ['bot-squad-seller-experience-front'],
          },
        },
        {
          name: ROUTE_NAMES.KYB.STEPS.STEP_2,
          component: () =>
            import(
              '~/scopes/kyb/pages/components/steps/AccountRequester/AccountRequester.vue'
            ),
          path: 'step-2',
          meta: {
            owners: ['bot-squad-seller-experience-front'],
          },
        },
        {
          name: ROUTE_NAMES.KYB.STEPS.STEP_3,
          component: () =>
            import(
              '~/scopes/kyb/pages/components/steps/LegalRepresentative/LegalRepresentative.vue'
            ),
          path: 'step-3',
          meta: {
            owners: ['bot-squad-seller-experience-front'],
          },
        },
        {
          name: ROUTE_NAMES.KYB.STEPS.STEP_4,
          component: () =>
            import(
              '~/scopes/kyb/pages/components/steps/BeneficialOwner/BeneficialOwner.vue'
            ),
          path: 'step-4',
          meta: {
            owners: ['bot-squad-seller-experience-front'],
          },
        },
        {
          name: ROUTE_NAMES.KYB.STEPS.STEP_5,
          component: () =>
            import(
              '~/scopes/kyb/pages/components/steps/LetterOfAuthorization/LetterOfAuthorization.vue'
            ),
          path: 'step-5',
          meta: {
            owners: ['bot-squad-seller-experience-front'],
          },
        },
        {
          name: ROUTE_NAMES.KYB.STEPS.REVIEW,
          component: () =>
            import('~/scopes/kyb/pages/components/steps/Review/Review.vue'),
          path: 'review',
          meta: {
            owners: ['bot-squad-seller-experience-front'],
          },
        },
      ],
    },
  ]
}

export default routes
